<template>
  <div v-if="!IS_LOADING.status" class="content-container flex flex-col w-full px-8">
    <Header1
      label="Admin Home"
    />
    <div>
      <h1>Welcome to epasnets Dashboard</h1>
    </div>
  </div>
</template>
<script>
  import Header1 from '_components/Headers/Header1';

  export default {
    components: {
      Header1,
    },
    data() {
      return {
        stats: [],
        totalStats: [],
      }
    },
    computed: {
      IS_LOADING()
      {
        return this.$store.getters.IS_LOADING
      },
    },
    mounted() {
      (async() => {
        try {
          await this.$store.commit('SET_WALLETS', [])
          await this.$store.commit('SET_IS_LOADING', { status: 'open' })
          await this.$store.commit('SET_IS_LOADING', { status: 'close' })
        } catch (err) {
          await this.$store.commit('SET_IS_LOADING', { status: 'close' })
        }
      })()
    },
    methods: {
    }
  }
</script>
<style lang='css' scoped>
</style>